import {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import logUserIn from '../../actions/logUserIn';
import {updateSidebarMode} from '../../actions/updateSidebarMode';

const Login = () => {

    // Set the state on change.
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loginText, setLoginText] = useState('Login');

    const {logInErrors} = useSelector((state) => state.user)

    const dispatch = useDispatch();

    const handleSubmit = (evt) => {
        evt.preventDefault();

        setLoginText( 'loading...' );

        // You have access to email & password here.
        dispatch(logUserIn({email, password}));
    }

    const forgotPasswordHandler = () => {

        dispatch( updateSidebarMode( 'forgotten' ) );
    }

    useEffect(() => {
        setLoginText('Login');
    }, [logInErrors])

    return (
        <form onSubmit={handleSubmit} autoComplete="off">

            <div className="errors">
                {logInErrors && logInErrors.length > 0 ? logInErrors.map((error, key) => (
                    <div className="alert error" key={key}>{error}</div>
                )) : ''}
            </div>

            <input
            required
            type="text"
            value={email}
            placeholder="Email address *"
            onChange={e => setEmail(e.target.value)} />

            <input
            required
            type="password"
            value={password}
            placeholder="Password *"
            onChange={e => setPassword(e.target.value)} />

            <p className="underline cursor color-yellow" tabIndex="0" onClick={forgotPasswordHandler}>Forgot password?</p>

            <button type="submit" className="button login">{loginText}</button>
        </form>
    );
}

export default Login;